// Helpers for AJAX calls
// Maybe this becomes a larger class or something eventually?

/**
 * @function buttonLoading Automagically disable/enable buttons while waiting for a promise to complete
 * @param {object} $btn jQuery object of button/icon to disable
 * @param {Promise|JQueryXHR} promise Promise you want to execute
 * @returns {Promise} Promise execution result
 */
export function buttonLoading($btn, promise) {
    $btn.prop('disabled', true);

    if (!(promise instanceof Promise)) {
        promise = Promise.resolve(promise);
    }

    if ($btn.data('loading-text')) {
        $btn.data('text', $btn.text()).text($btn.data('loading-text'));
    }

    return promise.finally(() => {
        $btn.prop('disabled', false);
        if ($btn.data('loading-text')) {
            $btn.text($btn.data('text'));
        }
    });
}

export function ajax(options) {
    return new Promise(function(resolve, reject) {
        $.ajax(options)
            .done(resolve)
            .fail(reject);
    });
}
